import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CanLandingGuard implements CanActivate {
  constructor(private _authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // Si hay sesión activa va a /home, si no va a /landing
    return this._authService.user$.pipe(
      take(1),
      map(user => {
        if (!user) {
          this.router.navigate(['/landing']);
          return false;
        }
        return true;
      })
    );
  }
}
